import { Chip, ChipProps, Tooltip } from "@mui/material";
import {
  displayStatus,
  StatusBgMap,
  StatusForegroundMap,
} from "~/utils/statuses";

type Props = ChipProps & {
  status: string;
  about?: 'visit' | 'visit_resource';
  subject?: { firstName: string } | null;
  cancellationReason?: string | null;
};

export default function VisitStatusChip({ status, about = 'visit', sx, cancellationReason, subject, ...props }: Props) {
  const subjectName = subject ? subject.firstName : "the virtual provider";
  const label = status === "notified" ? `Notified ${subjectName}` : displayStatus(status, about);

  return (
    <Tooltip title={cancellationReason} placement="top">
      <Chip
        size="small"
        sx={{
          //backgroundColor: StatusBgMap[status],
          background: label === "Drive Time"
            ? "repeating-linear-gradient(-45deg, #f3f3f3, #f3f3f3 11px, #e5e5e5 11px, #e5e5e5 22px)"
            : StatusBgMap[status],
          color: StatusForegroundMap[status],
          //borderColor: StatusForegroundMap[status],
          border: label === "En Route"
            ? "1px dashed transparent" 
            : label === "Shift Coverage"
            ? "1px dotted grey" 
            : StatusForegroundMap[status],
          fontSize: "13px",
          fontWeight: 500,
          borderRadius: "4px",
          ...sx,
        }}
        label={label}
        {...props}
      />
    </Tooltip>
  );
}
